import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const STUDENT = 'student'
const INTERVENTION_TYPE = 'intervention_type'
const TITLE = 'title'
const STATUS = 'status'
const INTERVENTION_PROVIDER = 'intervention_provider'
const INTERVENTION_PROVIDER_POSITION = 'intervention_provider_position'
const EVALUATION_PROVIDER = 'evaluation_provider'
const RTI_ERROR_CODES = 'rti_error_codes'
const INTERVENTION_STRATEGIES = 'intervention_strategies'
const INSTRUCTIONAL_STRATEGIES = 'instructional_strategies'
const BASELINE_ASSESSMENT_STRATEGIES = 'baseline_assessment_strategies'
const ACCOMMODATIONS = 'accommodations'
const MODIFICATIONS = 'modifications'
const PROGRESS_MONITORING_TOOLS = 'progress_monitoring_tools'
const MONITORING_METHODS = 'monitoring_methods'
const ASSESSMENT_TYPES = 'assessment_types'
const PROGRESS_RUBRIC = 'progress_rubric'
const NEED_FOR_SUPPORT = 'need_for_support'
const OBSERVED_DIFFICULTY = 'observed_difficulty'
const DESCRIPTION = 'description'
const STUDENT_STRENGTHS = 'student_strengths'
const STUDENT_WEAKNESSES = 'student_weaknesses'
const GOAL_BENCHMARKS = 'goal_benchmarks'
const GOAL_STANDARDS = 'goal_standards'
const GOAL_SHORT_TERM = 'goal_short_term'
const GOAL_LONG_TERM = 'goal_long_term'
const GOAL_OUTCOMES = 'goal_outcomes'
const CUSTOM_STRATEGY = 'custom_strategy'
const TIER = 'tier'
const START_DATE = 'start_date'
const END_DATE = 'end_date'
const MONITORING_TIMES_A_WEEK = 'monitoring_times_a_week'
const MONITORING_START_DATETIME = 'monitoring_start_datetime'
const MONITORING_DURATION_MINUTES = 'monitoring_duration_minutes'
const GROUP_SIZE = 'group_size'
const HAS_ACCOMMODATIONS = 'has_accommodations'
const HAS_MODIFICATIONS = 'has_modifications'
const MEASURE = 'measure'
const WEEKLY_SCORES = 'weekly_scores'
const BASELINE = 'baseline'
const GOAL_SCORE = 'goal_score'
const GOAL_PROGRESS_RATE = 'goal_progress_rate'
const STUDENT_PROGRESS_RATE = 'student_progress_rate'
const GOAL_ACHIEVED = 'goal_achieved'
const OBSERVATION = 'observation'
const DATA_COLLECTION_TIME = 'data_collection_time'
const TRACKING = 'tracking'
const TEACHER_MEETING_TIMES_A_MONTH = 'teacher_meeting_times_a_month'
const PARENT_MEETING_TIMES_A_MONTH = 'parent_meeting_times_a_month'
const SHARE_PROGRESS_WITH_TEACHERS = 'share_progress_with_teachers'
const SHARE_PROGRESS_WITH_PARENTS = 'share_progress_with_parents'
const NOTES = 'notes'
const STAFF_COLLABORATION_MEETING_TIMES_A_MONTH = 'staff_collaboration_meeting_times_a_month'
const EVALUATION_START_DATETIME = 'evaluation_start_datetime'
const EVALUATION_DURATION_MINUTES = 'evaluation_duration_minutes'
const EVALUATION_FREQUENCY = 'evaluation_frequency'
const PROGRESS_REVIEW_FREQUENCY = 'progress_review_frequency'
const IS_RATE_PLAN_SUCCESSFUL = 'is_rate_plan_successful'
const RATE_PLAN_EFFECTIVENESS = 'rate_plan_effectiveness'
const RATE_PLAN_FIDELITY = 'rate_plan_fidelity'
const RATE_COMMENTS = 'rate_comments'

/**
 * Form model
 */
const formModel = () => {
  return {
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
    },
    [INTERVENTION_TYPE]: {
      label: `${t('rti.intervention-type')}`,
      name: INTERVENTION_TYPE,
    },
    [TITLE]: {
      label: `${t('rti.intervention-name')}`,
      name: TITLE,
    },
    [STATUS]: {
      label: `${t('rti.program-status')}`,
      name: STATUS,
    },
    [INTERVENTION_PROVIDER]: {
      label: `${t('rti.intervention-provider')}`,
      name: INTERVENTION_PROVIDER,
    },
    [INTERVENTION_PROVIDER_POSITION]: {
      label: `${t('rti.intervention-provider-position')}`,
      name: INTERVENTION_PROVIDER_POSITION,
    },
    [EVALUATION_PROVIDER]: {
      label: `${t('rti.evaluation-provider')}`,
      name: EVALUATION_PROVIDER,
    },
    [INTERVENTION_STRATEGIES]: {
      label: `${t('common.intervention-strategies')}`,
      name: INTERVENTION_STRATEGIES,
    },
    [RTI_ERROR_CODES]: {
      label: `${t('common.error-codes')}`,
      name: RTI_ERROR_CODES,
    },
    [INSTRUCTIONAL_STRATEGIES]: {
      label: `${t('common.instructional-strategies')}`,
      name: INSTRUCTIONAL_STRATEGIES,
    },
    [BASELINE_ASSESSMENT_STRATEGIES]: {
      label: `${t('rti.baseline-assessment-strategies')}`,
      name: BASELINE_ASSESSMENT_STRATEGIES,
    },
    [ACCOMMODATIONS]: {
      label: `${t('common.accommodations')}`,
      name: ACCOMMODATIONS,
    },
    [MODIFICATIONS]: {
      label: `${t('common.modifications')}`,
      name: MODIFICATIONS,
    },
    [PROGRESS_MONITORING_TOOLS]: {
      label: `${t('common.progress-monitoring-tools')}`,
      name: PROGRESS_MONITORING_TOOLS,
    },
    [MONITORING_METHODS]: {
      label: `${t('common.monitoring-methods')}`,
      name: MONITORING_METHODS,
    },
    [ASSESSMENT_TYPES]: {
      label: `${t('common.assessment-types')}`,
      name: ASSESSMENT_TYPES,
    },
    [PROGRESS_RUBRIC]: {
      label: `${t('rti.progress-rubric')}`,
      name: PROGRESS_RUBRIC,
    },
    [NEED_FOR_SUPPORT]: {
      label: `${t('rti.need-for-support')}`,
      name: NEED_FOR_SUPPORT,
    },
    [OBSERVED_DIFFICULTY]: {
      label: `${t('rti.observed-difficulty')}`,
      name: OBSERVED_DIFFICULTY,
    },
    [DESCRIPTION]: {
      label: `${t('common.description')}`,
      name: DESCRIPTION,
    },
    [STUDENT_STRENGTHS]: {
      label: `${t('rti.student-strengths')}`,
      name: STUDENT_STRENGTHS,
    },
    [STUDENT_WEAKNESSES]: {
      label: `${t('rti.student-weaknesses')}`,
      name: STUDENT_WEAKNESSES,
    },
    [GOAL_BENCHMARKS]: {
      label: `${t('rti.goal-benchmarks')}`,
      name: GOAL_BENCHMARKS,
    },
    [GOAL_STANDARDS]: {
      label: `${t('rti.goal-standards')}`,
      name: GOAL_STANDARDS,
    },
    [GOAL_SHORT_TERM]: {
      label: `${t('rti.goal-short-term')}`,
      name: GOAL_SHORT_TERM,
    },
    [GOAL_LONG_TERM]: {
      label: `${t('rti.goal-long-term')}`,
      name: GOAL_LONG_TERM,
    },
    [GOAL_OUTCOMES]: {
      label: `${t('rti.goal-outcomes')}`,
      name: GOAL_OUTCOMES,
    },
    [CUSTOM_STRATEGY]: {
      label: `${t('rti.custom-strategy')}`,
      name: CUSTOM_STRATEGY,
    },
    [TIER]: {
      label: `${t('rti.tier')}`,
      name: TIER,
    },
    [START_DATE]: {
      label: `${t('common.start-date')}`,
      name: START_DATE,
    },
    [END_DATE]: {
      label: `${t('common.end-date')}`,
      name: END_DATE,
    },
    [MONITORING_TIMES_A_WEEK]: {
      label: `${t('rti.monitoring-times-a-week')}`,
      name: MONITORING_TIMES_A_WEEK,
    },
    [MONITORING_START_DATETIME]: {
      label: `${t('common.timing')}`,
      name: MONITORING_START_DATETIME,
    },
    [MONITORING_DURATION_MINUTES]: {
      label: `${t('common.duration-minutes')}`,
      name: MONITORING_DURATION_MINUTES,
    },
    [GROUP_SIZE]: {
      label: `${t('rti.group-size')}`,
      name: GROUP_SIZE,
    },
    [HAS_ACCOMMODATIONS]: {
      label: `${t('rti.has-accommodations')}`,
      name: HAS_ACCOMMODATIONS,
    },
    [HAS_MODIFICATIONS]: {
      label: `${t('rti.has-modifications')}`,
      name: HAS_MODIFICATIONS,
    },
    [MEASURE]: {
      label: `${t('rti.measure')}`,
      name: MEASURE,
    },
    [WEEKLY_SCORES]: {
      label: `${t('rti.weekly-scores')}`,
      name: WEEKLY_SCORES,
    },
    [BASELINE]: {
      label: `${t('rti.baseline')}`,
      name: BASELINE,
    },
    [GOAL_SCORE]: {
      label: `${t('rti.goal-score')} *`,
      name: GOAL_SCORE,
    },
    [GOAL_PROGRESS_RATE]: {
      label: `${t('rti.goal-progress-rate')} **`,
      name: GOAL_PROGRESS_RATE,
    },
    [STUDENT_PROGRESS_RATE]: {
      label: `${t('rti.student-progress-rate')}`,
      name: STUDENT_PROGRESS_RATE,
    },
    [GOAL_ACHIEVED]: {
      label: `${t('rti.goal-achieved')}`,
      name: GOAL_ACHIEVED,
    },
    [OBSERVATION]: {
      label: `${t('rti.observation')}`,
      name: OBSERVATION,
    },
    [DATA_COLLECTION_TIME]: {
      label: `${t('rti.data-collection-time')}`,
      name: DATA_COLLECTION_TIME,
    },
    [TRACKING]: {
      label: `${t('rti.tracking')}`,
      name: TRACKING,
    },
    [TEACHER_MEETING_TIMES_A_MONTH]: {
      label: `${t('rti.teacher-meeting-times-a-month')}`,
      name: PARENT_MEETING_TIMES_A_MONTH,
    },
    [PARENT_MEETING_TIMES_A_MONTH]: {
      label: `${t('rti.parent-meeting-times-a-month')}`,
      name: PARENT_MEETING_TIMES_A_MONTH,
    },
    [SHARE_PROGRESS_WITH_TEACHERS]: {
      label: `${t('rti.share-progress-with-teachers')}`,
      name: SHARE_PROGRESS_WITH_TEACHERS,
    },
    [SHARE_PROGRESS_WITH_PARENTS]: {
      label: `${t('rti.share-progress-with-parents')}`,
      name: SHARE_PROGRESS_WITH_PARENTS,
    },
    [NOTES]: {
      label: `${t('rti.log-intervention')}`,
      name: NOTES,
    },    
    [STAFF_COLLABORATION_MEETING_TIMES_A_MONTH]: {
      label: `${t('rti.staff-collaboration-meeting-times-a-month')}`,
      name: STAFF_COLLABORATION_MEETING_TIMES_A_MONTH,
    },
    [EVALUATION_START_DATETIME]: {
      label: `${t('common.timing')}`,
      name: EVALUATION_START_DATETIME,
    },
    [EVALUATION_DURATION_MINUTES]: {
      label: `${t('common.duration-minutes')}`,
      name: EVALUATION_DURATION_MINUTES,
    },
    [EVALUATION_FREQUENCY]: {
      label: `${t('rti.evaluation-frequency')}`,
      name: EVALUATION_FREQUENCY,
    },
    [PROGRESS_REVIEW_FREQUENCY]: {
      label: `${t('rti.progress-review-frequency')}`,
      name: PROGRESS_REVIEW_FREQUENCY,
    },   
    [IS_RATE_PLAN_SUCCESSFUL]: {
      label: `${t('rti.is-rate-plan-successful')}`,
      name: IS_RATE_PLAN_SUCCESSFUL,
    },  
    [RATE_PLAN_EFFECTIVENESS]: {
      label: `${t('rti.rate-plan-effectiveness')}`,
      name: RATE_PLAN_EFFECTIVENESS,
    },  
    [RATE_PLAN_FIDELITY]: {
      label: `${t('rti.rate-plan-fidelity')}`,
      name: RATE_PLAN_FIDELITY,
    },  
    [RATE_COMMENTS]: {
      label: `${t('rti.rate-comments')}`,
      name: RATE_COMMENTS,
    }, 
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [STUDENT]: null,
  [INTERVENTION_TYPE]: null,
  [TITLE]: '',
  [STATUS]: null,
  [INTERVENTION_PROVIDER]: null,
  [INTERVENTION_PROVIDER_POSITION]: '',
  [EVALUATION_PROVIDER]: null,
  [RTI_ERROR_CODES]: [],
  [INTERVENTION_STRATEGIES]: [],
  [INSTRUCTIONAL_STRATEGIES]: [],
  [BASELINE_ASSESSMENT_STRATEGIES]: [],
  [ACCOMMODATIONS]: [{
    category: null,
    items: []
  },],
  [MODIFICATIONS]: [{
    category: null,
    items: []
  },],
  [PROGRESS_MONITORING_TOOLS]: [],
  [MONITORING_METHODS]: [],
  [ASSESSMENT_TYPES]: [],
  [PROGRESS_RUBRIC]: null,
  [NEED_FOR_SUPPORT]: '',
  [OBSERVED_DIFFICULTY]: '',
  [DESCRIPTION]: '',
  [STUDENT_STRENGTHS]: '',
  [STUDENT_WEAKNESSES]: '',
  [GOAL_BENCHMARKS]: '',
  [GOAL_STANDARDS]: '',
  [GOAL_SHORT_TERM]: '',
  [GOAL_LONG_TERM]: '',
  [GOAL_OUTCOMES]: '',
  [CUSTOM_STRATEGY]: '',
  [TIER]: '',
  [START_DATE]: '',
  [END_DATE]: '',
  [MONITORING_TIMES_A_WEEK]: null,
  [MONITORING_START_DATETIME]: '',
  [MONITORING_DURATION_MINUTES]: '',
  [GROUP_SIZE]: '',
  [HAS_ACCOMMODATIONS]: false,
  [HAS_MODIFICATIONS]: false,
  [MEASURE]: '',
  [WEEKLY_SCORES]: '',
  [BASELINE]: '',
  [GOAL_SCORE]: '',
  [GOAL_PROGRESS_RATE]: '',
  [STUDENT_PROGRESS_RATE]: '',
  [GOAL_ACHIEVED]: false,
  [OBSERVATION]: '',
  [DATA_COLLECTION_TIME]: '',
  [TRACKING]: '',
  [TEACHER_MEETING_TIMES_A_MONTH]: null,
  [PARENT_MEETING_TIMES_A_MONTH]: null,
  [SHARE_PROGRESS_WITH_TEACHERS]: false,
  [NOTES]: '',
  [STAFF_COLLABORATION_MEETING_TIMES_A_MONTH]: null,
  [EVALUATION_START_DATETIME]: '',
  [EVALUATION_DURATION_MINUTES]: '',
  [EVALUATION_FREQUENCY]: null,
  [PROGRESS_REVIEW_FREQUENCY]: null,
  [IS_RATE_PLAN_SUCCESSFUL]: false,
  [RATE_PLAN_EFFECTIVENESS]: '',
  [RATE_PLAN_FIDELITY]: '',
  [RATE_COMMENTS]: ''
}

export default formModel
